import React from "react"
import { List, Button } from "antd"
import { get, uniqueId } from "lodash"
import alertSvg from "../../images/alert.svg"
import "./summary.less"
import { LeftOutlined } from "@ant-design/icons"
import { uuid } from "../../utils/functions"
import ModalCustom from "../../components/ModalCustom"
import { buttonAction_btns } from "../../components/Snowplow/config2"
import DOMPurify from "dompurify"

export default function SummaryScreen(props) {
  const [modalBackOpen, setModalBackOpen] = React.useState(false)
  const [modalImportAgainOpen, setModalImportAgainOpen] = React.useState(false)
  const [modalFinalize, setModalFinalize] = React.useState(false)

  let fileInputSummary

  const fileSelectedHandler = (event) => {
    event.preventDefault()
    let fd = new FormData()
    fd.append("uploaded_file", event.target.files[0])
    props.uploadTemplate(fd)
    fileInputSummary.value = ""
  }

  const saveOK = (confirm = false) => {
    const { count_import, count_update, count_error } = props

    const params = {
      count_import,
      count_update,
      count_error,
    }

    props.onFinalize(params)
  }

  const handleTextResumeActionPlan = (type = "success") => {
    const { textResumeActionPlan } = props
    if (!textResumeActionPlan) return false

    return textResumeActionPlan[type]
  }

  const handleTextResumeTask = (type = "success") => {
    const { textResumeTask } = props
    if (!textResumeTask) return false

    return textResumeTask[type]
  }

  const hasCompanyErrors = get(props, "company_errors", []).length > 0
  const hasFreshchat =
      typeof window.Intercom !== "undefined" &&
      window.self === window.top;
      
  return (
    <React.Fragment>
      <div className="summary-screen-ap">
        <div className="summary-screen-ap-header">
          <div className="summary-screen-ap-btn-back">
            <span
              onClick={() => setModalBackOpen(true)}
              style={{ minWidth: 200 }}>
              <LeftOutlined /> {props.backTitle || props.title}
            </span>
          </div>
          {!props.hideHeader && (
            <React.Fragment>
              <div className="summary-screen-ap-title">
                {props.typeImport || "Importación"} de {props.title}
              </div>
              <div className="summary-screen-ap-description">
                Revisa si se ha producido algún error en la importación de la
                información. De ser el caso, realiza las correcciones necesarias
                y vuelve a importar el archivo.
              </div>
            </React.Fragment>
          )}
          <div className="summary-screen-ap-summary-title">
            Resumen de importación
          </div>
          <div className="summary-screen-ap-infov3">
            {!hasCompanyErrors && (
              <div className="successList">
                <div className="resumeSuccess">
                  {handleTextResumeActionPlan("success") ? (
                    handleTextResumeActionPlan("success")
                  ) : (
                    <React.Fragment>
                      <span>{props.count_import || 0} </span>
                      {props.typeImport
                        ? `${props.typeImportText}${
                            props.count_import > 1 ? "s" : ""
                          }`
                        : props.title}{" "}
                      importada${props.count_import > 1 ? "s" : ""}
                    </React.Fragment>
                  )}
                </div>
                <div className="resumeSuccess">
                  {handleTextResumeTask("success") ? (
                    handleTextResumeTask("success")
                  ) : (
                    <React.Fragment>
                      <span>{props.count_import || 0} </span>
                      {props.typeImport
                        ? `${props.typeImportText}${
                            props.count_import > 1 ? "s" : ""
                          }`
                        : props.title}{" "}
                      importada${props.count_import > 1 ? "s" : ""}
                    </React.Fragment>
                  )}
                </div>
              </div>
            )}

            {!hasCompanyErrors && props.hasUpdates && (
              <div style={{ marginLeft: 16 }} className="resumeSuccess">
                <span>{props.count_update} </span>
                {props.typeImport ? props.typeImportText : props.title}{" "}
                actualizados
              </div>
            )}

            <div className="failedList">
              <div
                className="resumeFailed"
                style={{ marginLeft: hasCompanyErrors ? 0 : "" }}>
                {handleTextResumeActionPlan("failed") ? (
                  handleTextResumeActionPlan("failed")
                ) : (
                  <React.Fragment>
                    <span>{props.count_error || 0} </span>
                    {`${
                      props.typeImport
                        ? `${props.typeImportText}${
                            props.count_error != 1 ? "s" : ""
                          }`
                        : props.title
                    } sin importar`}
                  </React.Fragment>
                )}
              </div>
              <div
                className="resumeFailed"
                style={{ marginLeft: hasCompanyErrors ? 0 : "" }}>
                {handleTextResumeTask("failed") ? (
                  handleTextResumeTask("failed")
                ) : (
                  <React.Fragment>
                    <span>{props.count_error || 0} </span>
                    {`${
                      props.typeImport
                        ? `${props.typeImportText}${
                            props.count_error != 1 ? "s" : ""
                          }`
                        : props.title
                    } sin importar`}
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
          <p style={{ marginBottom: 0, color: "#4F4F4F" }}>
            A continuación se presentan los{" "}
            <span style={{ fontWeight: 600 }}>motivos de error </span>
            en la importación.
          </p>
        </div>
        <div className="summary-screen-ap-body">
          {hasCompanyErrors ? (
            <List
              key={uuid()}
              className="summary-screen-ap-list"
              size="large"
              locale={{ emptyText: "No hay errores para mostrar" }}
              bordered
              dataSource={props.company_errors}
              renderItem={(item) => {
                const sanitizedHTML = DOMPurify.sanitize(item);
                return (
                  <List.Item key={uuid()}>
                    <div className="ant-list-item-content-div">
                      <span dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />
                    </div>
                  </List.Item>
                )
              }}
            />
          ) : (
            <List
              key={uuid()}
              className="summary-screen-ap-list"
              style={{ maxWidth: props.maxWidthTable }}
              size="large"
              locale={{ emptyText: "No hay errores para mostrar" }}
              header={
                <div
                  className="ant-list-header-div"
                  style={{ gridTemplateColumns: props.gridHeader }}>
                  {props.header.map((content, index) => (
                    <span key={uniqueId()}>{content}</span>
                  ))}
                </div>
              }
              bordered
              dataSource={props.list_errors}
              renderItem={(item) => (
                <List.Item key={uuid()}>
                  <div
                    className="ant-list-item-content-div"
                    style={{ gridTemplateColumns: props.gridContent }}>
                    {props.content.map((content, idx) =>
                      content === "error" ? (
                        <ul>
                          {item.errors.map((error) => (
                            <li key={uniqueId()}>{error}</li>
                          ))}
                        </ul>
                      ) : content === "row" ? (
                        <span key={uniqueId()}>{item.row}</span>
                      ) : content === "apellido" ? (
                        <span key={uniqueId()}>{`${item.values
                          .apellido_paterno || ""} ${item.values
                          .apellido_materno || ""}`}</span>
                      ) : (
                        <span key={uniqueId()}>{item.values[content]}</span>
                      )
                    )}
                  </div>
                </List.Item>
              )}
            />
          )}

          <div className= {`summary-screen-ap-buttons ${hasFreshchat ? "buttonsFooterMargin" : ""}`} >
            <Button
              onClick={() => {
                setModalImportAgainOpen(true)
                buttonAction_btns("Reintentar importacion de plan de accion")
              }}
              style={{ boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.15)" }}
              type="ghost">
              Reintentar
            </Button>
            {!hasCompanyErrors && !props.hideFinalize && (
              <Button
                type="primary"
                onClick={() => {
                  props.modalFinalize ? setModalFinalize(true) : saveOK()
                  buttonAction_btns("Finalizar importacion de plan de accion")
                }}>
                Finalizar
              </Button>
            )}
          </div>
        </div>
      </div>

      <ModalCustom
        modalOpen={modalBackOpen}
        showFooter
        onOk={() =>
          props.urlBackH
            ? props.urlBackF()
            : props.history.push(props.urlBack || "/organization")
        }
        onCancel={() => setModalBackOpen(false)}>
        <img src={alertSvg} className="alertIcon" />
        <span style={{ fontWeight: 600, fontSize: 14 }}>
          {props.backModalTitle ||
            "¿Estas seguro de que deseas salir de la importación?"}
        </span>
        <p style={{ fontSize: 13, marginTop: 8 }}>
          La información no será registrada y deberás iniciar un nuevo proceso
          de importación.
        </p>
      </ModalCustom>

      <ModalCustom
        modalOpen={modalImportAgainOpen}
        showFooter
        onOk={() => {
          setModalImportAgainOpen(false)
          fileInputSummary.click()
        }}
        onCancel={() => setModalImportAgainOpen(false)}>
        <img src={alertSvg} className="alertIcon" />
        <span style={{ fontWeight: 600, fontSize: 14 }}>
          {props.modalImportAgainTitle ||
            "¿Estás seguro de que deseas realizar una nueva importación?"}
        </span>
        <p style={{ fontSize: 13, marginTop: 8 }}>
          La información no será registrada y deberás iniciar un nuevo proceso
          de importación.
        </p>
      </ModalCustom>

      <ModalCustom
        modalOpen={modalFinalize}
        textButton="Eliminar"
        colorButton="#2694FC"
        onOkId="btnFinalizar"
        showFooter
        onOk={() => {
          setModalFinalize(false)
          saveOK(true)
        }}
        onCancel={() => setModalFinalize(false)}
        textButton="Finalizar"
        width={props.modalFinalizeWidth}>
        <img src={alertSvg} className="alertIcon" />
        {props.modalFinalize && props.modalFinalize != "collaborators-cease" ? (
          props.modalFinalize
        ) : (
          <span>
            <span style={{ fontSize: 14, fontWeight: 600 }}>
              ¿Estás seguro de que deseas eliminar a los colaboradores?
            </span>

            {props.measures_affected && (
              <p style={{ fontSize: 13, marginTop: 8 }}>
                Se <b>eliminarán</b> tambien sus respuestas en las mediciones
                que
                <br /> participaron, que aún no han sido oficializadas:
                <br />
                <br />
                {props.measures_affected.map((measure, index) => (
                  <span key={uniqueId()}>
                    {measure.name}
                    <br />
                  </span>
                ))}
              </p>
            )}

            <p style={{ fontSize: 13, marginTop: 8 }}>
              La acción <b>no será reversible</b>.
            </p>
          </span>
        )}
      </ModalCustom>
      <input
        style={{ display: "none" }}
        type="file"
        onChange={fileSelectedHandler}
        ref={(_fileInputSummary) => (fileInputSummary = _fileInputSummary)}
      />
    </React.Fragment>
  )
}
